import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import { LoanCategory } from "./LoanCategory";
import { LoanCategoryTable } from "./LoanCategoryTable";
import formatCurrency from "functions/formatCurrency";
import { useUser } from "components/hooks/useUser";

export function CumulativeLoansOverview() {
  const { loans, loansSummary: { amountOwed, estMonthlyPayment } = {} } =
    useUser((user) => user.loanHistoryCumulative);

  return (
    <div>
      <p style={{ marginTop: 0 }}>
        To see definitions for financial terms, see the{" "}
        <Link to="#resources">Resources</Link> section at the bottom of this
        card.
      </p>

      {loans.map((loanCategory) => (
        <LoanCategory key={loanCategory.category} loanCategory={loanCategory} />
      ))}

      <h3>Grand Total</h3>
      <LoanCategoryTable $grandTotals={true}>
        <thead>
          <tr>
            <th></th>
            <th>Total Calculated Debt</th>
            <th>Est. Monthly Payment</th>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <td>Calculated Cumulative Debt</td>
            <td>{formatCurrency(amountOwed)}</td>
            <td>{formatCurrency(estMonthlyPayment)}</td>
          </tr>
        </tfoot>
      </LoanCategoryTable>
    </div>
  );
}
